import createColor from 'color';
import { StyleSheet } from 'aphrodite/no-important';
import { mixins } from '@blend/consumer-components';
import * as deploymentConfig from 'login-utils/deploymentConfig';

const GLOBALS = '__GLOBAL_STYLES__';

const globalExtension = {
  selectorHandler: (selector, baseSelector, generateSubtreeStyles) =>
    baseSelector.includes(GLOBALS) ? generateSubtreeStyles(selector) : null,
};

const actionColor = deploymentConfig.getOrganizationColors().action;
const actionColorLightness = createColor(actionColor).lightness();
// .extend currently isn't included in the Aphrodite types, and adding it is actually
// really tricky because it returns effectively a new copy of the entire Aphrodite API,
// which is hard to type without a lot of duplication.
const extended = (StyleSheet as any).extend([globalExtension]);

/**
 * These styles are globally applied across the app, although are no-importanted
 * so they can be overridden by any more explicit style.
 *
 * This pattern was taken from https://github.com/Khan/aphrodite/issues/139#issuecomment-266500624.
 */

const styles = extended.StyleSheet.create({
  [GLOBALS]: {
    a: {
      color: actionColor,
    },
    // Below colors are for Lottie loading animations only
    '.actionColor path': {
      fill: actionColor,
      stroke: actionColor,
    },
    '.actionColorFillOnly path': {
      fill: actionColor,
    },
    // with some colors lightening by 50% can make it white (if the lightness is > 50), which we don't want because
    // backgrounds can be white. Putting a cap on these so they don't become true white (i.e. don't go beyond 90% light)
    '.actionAccent_light path': {
      fill: mixins.lighten(actionColor, Math.min(90 - actionColorLightness, 50) / 100),
    },
    '.actionAccent_lighter path': {
      fill: mixins.lighten(actionColor, Math.min(90 - actionColorLightness, 50) / 100),
    },
    '.actionAccent_dark path': {
      fill: mixins.lighten(mixins.desaturate(actionColor, 0.3), Math.min(60 - actionColorLightness, 20) / 100),
    },
    '.actionAccent path': {
      fill: mixins.lighten(actionColor, Math.min(90 - actionColorLightness, 50) / 100),
      stroke: mixins.lighten(actionColor, Math.min(90 - actionColorLightness, 50) / 100),
    },
  },
});

export default extended.css(styles[GLOBALS]);
